import React from 'react';
import { motion } from 'framer-motion';
import ElasticButton from '../ui/ElasticButton';

const StickyTimeline = () => {
    const steps = [
        { title: "Connect", desc: "Drag drop connectors for DBs, APIs, or files." },
        { title: "Transform", desc: "Use visual nodes to transform and filter data." },
        { title: "Deploy", desc: "One-click deploy to a scalable serverless endpoint." },
    ];

    return (
        <section className="py-32 bg-cyber-black relative">
            <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row gap-20">
                <div className="md:w-1/3">
                    <div className="sticky top-32">
                        <h2 className="text-4xl font-bold text-white mb-4">How It Works</h2>
                        <p className="text-lg text-gray-400 mb-8">
                            A simple, linear process to take you from idea to production in minutes.
                        </p>
                        <ElasticButton primary>Read Documentation</ElasticButton>
                    </div>
                </div>

                <div className="md:w-2/3 space-y-32">
                    {steps.map((step, idx) => (
                        <motion.div
                            key={idx}
                            initial={{ opacity: 0, x: 50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true, margin: "-20% 0px -20% 0px" }}
                            transition={{ duration: 0.8 }}
                            className="flex gap-8 group"
                        >
                            <div className="flex flex-col items-center">
                                <div className="w-16 h-16 rounded-2xl bg-cyber-gray border border-gray-700 flex items-center justify-center text-2xl font-bold text-gray-400 group-hover:bg-neon-blue group-hover:text-black transition-colors duration-500 shadow-xl group-hover:shadow-[0_0_20px_rgba(0,243,255,0.4)]">
                                    {idx + 1}
                                </div>
                                {idx !== steps.length - 1 && (
                                    <div className="w-px h-full bg-gray-800 my-4 group-hover:bg-neon-blue transition-colors" />
                                )}
                            </div>
                            <div className="pt-4">
                                <h3 className="text-3xl font-bold text-white mb-4">{step.title}</h3>
                                <p className="text-xl text-gray-400 leading-relaxed max-w-lg">{step.desc}</p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default StickyTimeline;
